exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-card[data-v-65d9a6a2]{min-height:120px}.content-card a[data-v-65d9a6a2]{color:inherit!important}.content-card+.content-card[data-v-65d9a6a2]{margin-top:1rem}.border-4[data-v-65d9a6a2]{border-width:4px!important}", ""]);

// exports
